import configService from "../services/configurations.service";

const state = {
  requestPending: false,
  configurations: [],
  selectedConfig: null,
  songs: []
};

const getters = {
  pending: state => state.requestPending,
  selectedConfig: state => state.selectedConfig,
  configurations: state => state.configurations,
  tileConfigs: state => {
    let returnConfigs = new Array(6);
    for (let h = 0; h < returnConfigs.length; h++) {
      returnConfigs[h] = Object.assign({}, { name: "", music: "", speed: "" });
    }
    for (let i = 0; i < state.configurations.length; i++) {
      returnConfigs[i].name = state.configurations[i].config_name;
      // music title
      let song = state.songs.find(x => x.id === state.configurations[i].music);
      if (typeof song !== "undefined") {
        returnConfigs[i].music = song.title;
      } else {
        returnConfigs[i].music = "-----";
      }
      let averageSpeed = 0;
      for (let j = 0; j < state.configurations[i].effects.length; j++) {
        averageSpeed += state.configurations[i].effects[j].params.find(
          x => x.key === "Taktgeschwindigkeit"
        ).value;
      }
      returnConfigs[i].speed = averageSpeed;
    }
    return returnConfigs;
  },
  getConfigByIndex: state => index => state.configurations[index],
  getConfigByName: state => name => state.find(e => e.config_name === name),
  songs: state => state.songs
};

const actions = {
  loadConfigurations({ commit }) {
    return new Promise(async (resolve, reject) => {
      commit("startRequest");
      try {
        const [response, songArray] = await Promise.all([
          configService.getConfigurationsFromServer(),
          configService.getSongsFromServer()
        ]);
        commit("updateConfigs", response.data.configs);
        commit("updateSongs", songArray);
        commit("endRequest");
        resolve();
      } catch (e) {
        commit("endRequest");
        reject(e);
      }
    });
  },
  selectConfigForEdit({ commit }, index) {
    return new Promise(resolve => {
      commit("selectConfig", index);
      resolve();
    });
  },
  updateSelectedConfig({ commit, state }, config) {
    return new Promise(resolve => {
      if (state.selectedConfig === null) {
        commit("selectConfig", 0);
      }
      commit("updateSelected", config);
      resolve();
    });
  },
  saveConfigurations({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      commit("startRequest");
      try {
        const response = await configService.setConfigurations(
          state.configurations
        );
        commit("endRequest");
        resolve(response);
      } catch (e) {
        commit("endRequest");
        reject(e);
      }
    });
  },
  deleteSelectedConfig({ commit, state, dispatch }) {
    return new Promise(async (resolve, reject) => {
      try {
        if (state.configurations.length > 0) {
          commit("deleteSelected");
          dispatch("saveConfigurations");
          resolve();
        } else {
          reject("Cannot delete nothing");
        }
      } catch (e) {
        reject(e);
      }
    });
  }
};

const mutations = {
  startRequest(state) {
    state.requestPending = true;
  },
  endRequest(state) {
    state.requestPending = false;
  },
  updateConfigs(state, newConfigs) {
    state.configurations = newConfigs;
  },
  updateSongs(state, newSongs) {
    state.songs = newSongs;
  },
  selectConfig(state, number) {
    if (number > state.configurations.length)
      state.selectedConfig = state.configurations.length;
    else state.selectedConfig = number;
  },
  updateSelected(state, config) {
    state.configurations[state.selectedConfig] = config;
  },
  deleteSelected(state) {
    state.configurations.splice(state.selectedConfig, 1);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
